module.exports = __webpack_public_path__ + "static/media/storage.cf208068.png";